import "./HandrulesButtons.css"
import { useApi } from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import lockIco from "../../../assets/icons/lock.svg"
import config from "../../../config";

const HandrulesButtons = ({token, editMode, lock}) => {
	const { api } = useApi();
	const arr = ["T", "C", "R", "Q", "NT"];
	function addRule(type){
		if(editMode) {
			if(lock === type) {
				let path = `handrules/${config.handrulesLobbyId}/unlock`;
				api(path, "POST");
			} else {
				let path = `handrules/${config.handrulesLobbyId}/lock/` + type;
				api(path, "POST");
				console.log(type);
			}
		} else {
			let path = `handrules/${config.handrulesLobbyId}/` + type;
			api(path, "POST");
			console.log(type);
		}
	}

	function lockIcon() {
		return (<img className="lockIcon" src={lockIco} alt='locked'/>)
	}

	return (
		<div className="handrulesButtonsContainer">
			<div className="handrulesButton" id="firstButton" onClick={() => addRule("T")}>{arr.indexOf(lock) === 0 ? lockIcon() : "T"}</div>
			<div className="handrulesButton" onClick={() => addRule("C")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 1 ? lockIcon() : "C"}</div>
			<div className="handrulesButton" onClick={() => addRule("R")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 2 ? lockIcon() : "R"}</div>
			<div className="handrulesButton" onClick={() => addRule("Q")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 3 ? lockIcon() : "Q"}</div>
			<div className="handrulesButton" id="lastButton" onClick={() => addRule("NT")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 4 ? lockIcon() : "NT"}</div>
		</div>
	)
}

export default HandrulesButtons;